import Rails from '@rails/ujs'

class StripeForm {
  stripe = null
  elements = null
  card = null
  formElement = null
  submitButton = null
  clientSecret = null

  style = {
    base: {
      iconColor: '#6F4DB2',
      color: '#432f6a',
      fontFamily: '"Proxima Nova", "Helvetica Neue", Helvetica, sans-serif',
      fontSmoothing: 'antialiased',
      fontSize: '16px',
      '::placeholder': {
        color: '#A894D1',
      },
    },
    invalid: {
      color: '#B95046',
      iconColor: '#B95046',
    },
  }

  constructor(stripeToken, formElement) {
    this.formElement = formElement
    this.submitButton = this.formElement.querySelector('.js-submit')

    // Create a Stripe client.
    this.stripe = Stripe(stripeToken)

    // Fetch the client secret for the SetupIntent
    this.clientSecret = this.formElement.querySelector(
      '.js-stripe-setupintent-secret'
    ).value

    // Create an instance of Elements.
    this.elements = this.stripe.elements()

    // Create an instance of the card Element.
    this.card = this.elements.create('card', {
      style: this.style,
      hidePostalCode: document.querySelector('.js-address-zip') !== undefined,
    })

    // Add an instance of the card Element into the `card-element` <div>.
    this.card.mount('#stripe-card-element')

    // Handle real-time validation errors from the card Element.
    this.card.addEventListener('change', e => {
      this.validateCard(e)
    })

    // Handle form submission.
    this.formElement.addEventListener('submit', e => {
      if (document.querySelector('.js-address-zip') !== undefined) {
        this.submitFormWithAddress(e)
      } else {
        this.submitForm(e)
      }
    })
  }

  validateCard(event) {
    const displayError = document.getElementById('card-errors')
    if (event.error) {
      displayError.textContent = event.error.message
    } else {
      displayError.textContent = ''
    }

    // Ensure the submit button is not disabled.
    this.submitButton.removeAttribute('disabled')
  }

  submitFormWithAddress(event) {
    event.preventDefault()

    const address_line1 = document
      .querySelector('.js-address-line1')
      .value.trim()
    const address_city = document.querySelector('.js-address-city').value.trim()
    const address_region = document
      .querySelector('.js-address-region')
      .value.trim()
    const address_state = document
      .querySelector('.js-address-state')
      .value.trim()
    const address_zip = document.querySelector('.js-address-zip').value.trim()
    const address_country = document
      .querySelector('.js-address-country')
      .value.trim()

    // Remove previous validation errors.
    document.querySelectorAll('.form_field--error').forEach(field => {
      field.classList.remove('form_field--error')
      const label = field.querySelector('.form_field-note--error')
      if (label) {
        field.removeChild(label)
      }
    })

    // Validate the address fields required for taxation.
    const validationErrors = []

    if (address_line1.length === 0) {
      validationErrors.push('.js-address-line1')
    }
    if (address_zip.length === 0) {
      validationErrors.push('.js-address-zip')
    }
    if (address_country.length === 0) {
      validationErrors.push('.js-address-country')
    }

    if (validationErrors.length > 0) {
      // Show errors.
      validationErrors.forEach(selector => {
        const field = document.querySelector(selector)

        const label = document.createElement('p')
        label.classList.add('form_field-note')
        label.classList.add('form_field-note--error')
        label.innerHTML = 'Can’t be blank.'

        field.parentNode.insertBefore(label, field.nextSibling)
        field.parentNode.classList.add('form_field--error')
      })

      // Re-enable button.
      setTimeout(() => {
        Rails.enableElement(event.target)
      }, 50)

      return
    }

    this.submitToStripe({
      line1: address_line1,
      city: address_city,
      state: address_country === 'US' ? address_state : address_region,
      postal_code: address_zip,
      country: address_country,
    })
  }

  submitForm(event) {
    event.preventDefault()

    this.submitToStripe({})
  }

  submitToStripe(address) {
    // Disable the submit button.
    this.submitButton.setAttribute('disabled', 'disabled')

    this.stripe
      .confirmCardSetup(this.clientSecret, {
        payment_method: {
          card: this.card,
          billing_details: {
            address: address,
          },
        },
      })
      .then(result => {
        if (result.error) {
          // Inform the user if there was an error.
          const errorElement = document.getElementById('card-errors')
          errorElement.textContent = result.error.message

          // Re-enable the submit button.
          this.submitButton.removeAttribute('disabled')
        } else {
          // Submit the form
          this.formElement.submit()
        }
      })
  }
}

document.addEventListener('turbolinks:load', () => {
  const stripeToken = document.querySelector(
    'meta[name="stripe-token"]'
  ).content
  const form = document.querySelector('.js-stripe-form')

  if (form) {
    new StripeForm(stripeToken, form)
  }
})
